import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    display: none;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.toast-fade-out {\n  animation: fadeOut 0.5s ease-in-out forwards;\n}\n\n.toast-fade-in {\n  animation: fadeIn 0.5s ease-in-out forwards;\n}\n";
styleInject(css_248z);

export { css_248z as default };
